export enum AuthenticationStatus {
  SignedOut,
  NewPasswordRequired,
  SignedIn
};